module.exports = __webpack_public_path__ + "static/media/ZHUHAI-1 01 (CAS 4A).3b8ef7a8.czml";